export enum GoogleMapLibrary {
  Drawing = 'drawing',
  Geometry = 'geometry',
  Places = 'places',
  Visualization = 'visualization',
  Marker = 'marker',
}
